import React from "react";
import { Container, Box, Heading, Progress } from "@chakra-ui/react";
import { Redirect, RouteComponentProps } from "react-router";
import { CSSReset } from "@chakra-ui/react";
import ProductQuery from "../../graphql/queries/product/ProductQuery";
import InsightsProductForm from "../../components/InsightsProductForm";

interface MatchParams {
  id: string;
}

const EditProduct: React.FC<RouteComponentProps<MatchParams>> = (props) => {
  const { match } = props;

  return (
    <ProductQuery id={match.params.id}>
      {({ data, loading, error }) => {
        if (error) return "Oops, an unknown error occurred";
        if (loading) return <Progress size="xs" isIndeterminate />;
        if (!data?.product) {
          return <Redirect to="/admin/products" />;
        }

        return (
          <Container maxWidth={1250}>
            <CSSReset />
            <Box
              borderWidth={{ lg: 1 }}
              p={{ lg: 5 }}
              borderRadius={{ lg: 5 }}
              shadow={{ lg: "lg" }}
            >
              <Heading as="h3" size="lg">
                Edit Product
              </Heading>
              <Box mt={5}>
                <InsightsProductForm product={data.product} />
              </Box>
            </Box>
          </Container>
        );
      }}
    </ProductQuery>
  );
};

export default EditProduct;
